import PartsCategory from './types/PartsCategory';

const partsTree = require('../partsTree.json');

type PartsCategories = [PartsCategory];

const partsCategories: PartsCategories = partsTree.children.map((folder) => ({
  ...folder,
  children: folder.children
    .sort(
      (childA, childB) => childA.name.localeCompare(childB.name) // Ensure _none is first, as children seem to be sorted by createdAt or something
    )
    // We need to do this here at app start, as requires can't be dynamic during normal runtime.
    .map((child) => ({ ...child, requirePath: require(`../${child.path}`) })),
}));

export default partsCategories;
